import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { useSelector, useDispatch } from "react-redux";
import { injectIntl } from "react-intl";
import { fetchNewsletterDetail } from "actions/newsletterActions";
import { Loader } from "cxa-components";
import messages from "components/messagesDescription";
import withMatchMediaProps from "@hocs/with-match-media-props";
import { isNewsletterPDF } from "../../utils";

const NewsletterPage = ({ intl, match, isNarrowScreen, history }) => {
  const dispatch = useDispatch();
  const itemId = match.params.id;
  useEffect(() => {
    dispatch(fetchNewsletterDetail(itemId));
  }, []);

  const newsletters = useSelector(state => state.newsletters);
  if (newsletters.isFetching) {
    return <Loader />;
  }
  return (
    <article className="card">
      <header>
        {/* <h2>{newsletters.selectedItem.title}</h2> */}
        <div dangerouslySetInnerHTML={{ __html: newsletters.selectedItem.title }} />
      </header>
      <div style={{ marginTop: "0" }}>
        <button
          className="button--secondary"
          style={{ float: "right" }}
          onClick={() => history.goBack()}
        >
          {intl.formatMessage(messages.backButtonDescription)}
        </button>
      </div>

      <section>
        {newsletters.selectedItem.coverImage && (
          <img src={newsletters.selectedItem.coverImage} alt="cover" />
        )}
        {newsletters.selectedItem.summary && (
          <div dangerouslySetInnerHTML={{ __html: newsletters.selectedItem.summary }} />
        )}
        {newsletters.selectedItem.body && (
          <div dangerouslySetInnerHTML={{ __html: newsletters.selectedItem.body }} />
        )}
        {newsletters.selectedItem.newsletterFile &&
          (isNewsletterPDF(newsletters.selectedItem.newsletterFile) ? (
            <a
              href={newsletters.selectedItem.newsletterFile}
              target="_blank"
              rel="noopener noreferrer"
            >
              {newsletters.selectedItem.title}
            </a>
          ) : (
            <img src={newsletters.selectedItem.newsletterFile} alt="uploaded file" />
          ))}
      </section>
    </article>
  );
};
NewsletterPage.propTypes = {
  newsletterList: PropTypes.array.isRequired,
  intl: PropTypes.object,
  isFetching: PropTypes.bool,
  history: PropTypes.object,
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  isNarrowScreen: PropTypes.bool.isRequired,
};

export default injectIntl(
  withMatchMediaProps({
    isNarrowScreen: {
      maxWidth: 680,
    },
  })(NewsletterPage)
);



// WEBPACK FOOTER //
// ./components/wellness/NewsletterPage.jsx